import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-coming-soon-ecommerce',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './coming-soon-ecommerce.component.html',
  styleUrl: './coming-soon-ecommerce.component.css'
})
export class ComingSoonEcommerceComponent {

  texts: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().comingSoonEcommerce;
  }

}
